export default __webpack_public_path__ + "static/media/noun_Battery_3408796.3177fe98.svg";